import React from 'react';

import {observer} from "mobx-react";
import {AllScoresWidgetAsync} from "../../../../../widgets/all-scores-widget/components/all-scores-widget.async";
import {useLocation} from "react-router-dom";

export const SideBarModuleAllScores = observer(({controller}) => {
  const {state} = controller;
  const {shouldRenderAllScoresSideBar, sportTypeId, showOdds, isLive, date, isBettingPage} = state;
  const location = useLocation();

  const allScoresProps = {
    sportTypeId,
    showOdds,
    location,
    isLive,
    date,
    isBettingPage
  }

  return shouldRenderAllScoresSideBar ? <AllScoresWidgetAsync {...allScoresProps}/> : null

});
